"use client";

import { useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import { useHubUser } from "@/hooks/user/useHubUser";

export function useHyperliquidAccount() {
  const { hubUser } = useHubUser();
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);

  const hlAccounts = useMemo(() => {
    return hubUser?.exchangeAccounts?.filter((a) => a.exchangeId === "hyperliquid") ?? [];
  }, [hubUser?.exchangeAccounts]);

  const selectedAccount = useMemo(() => {
    if (selectedAccountId != null) {
      return hlAccounts.find((a) => a.id === selectedAccountId) ?? null;
    }
    // Auto-select if only one account
    if (hlAccounts.length === 1) {
      return hlAccounts[0];
    }
    return null;
  }, [hlAccounts, selectedAccountId]);

  const setSelectedAccount = (account: HubExchangeAccount | null) => {
    setSelectedAccountId(account?.id ?? null);
  };

  return {
    hlAccounts,
    selectedAccount,
    setSelectedAccount,
  };
}
